module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm01"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Front Cover:")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("An unidentified power car powers through Defford on 28 September 2003 whilst leading the final HST-operated Penzance-Glasgow Central service")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fm02"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Rear Cover:")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Between 1997 and 2007 the main West Coast Main Line route was shared by both Virgin Cross Country and Virgin West Coast franchises as noted on 26 January 2005 when a Class 220 ‘Voyager’ trainset heading north out of Preston was viewed from St Michael’s church tower when passing a southbound Class 390 ‘Pendolino’ trainset approaching Preston station")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-538c2152","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Fm01.vue
// module id = 60
// module chunks = 0